import cx from 'classnames';

import {Loader, Icon} from 'components';

type Props = {
    success: boolean;
    error?: boolean;
    inProgress?: boolean;
    className?: string;
};

export const StatusIcon: React.FC<Props> = ({success, error, inProgress, ...rest}: Props) => {
    if (inProgress) {
        return <div {...rest} className={cx('tw-relative tw-w-4 tw-h-4', rest.className)}><Loader /></div>;
    } else if (success) {
        return <Icon name='check-circle' color='success' size='sm' {...rest} />;
    } else if (error) {
        return <Icon name='alert-circle' color='alert' size='sm' {...rest} />;
    }

    return null;
};
